/* eslint-disable no-console */
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { ReactNode, useState } from 'react';

import { Util } from '@finley-technologies/finley-types';

import { UploadCashBalanceForm } from 'packages/manualDataTapeUploads/ui/UploadCashBalanceForm';

type CashBalanceUploadButtonProps = {
  children: ReactNode;
  organizationId: string;
  creditFacilityId: string;
  modalHeaderText?: string;
  reportingDate: Util.FullDateStr;
  fileVersion: number;
  onUploadStart: (cfId: string) => void;
  onUploadEnd: (cfId: string) => void;
};
export const CashBalanceUploadButton = ({
  children,
  modalHeaderText,
  reportingDate,
  fileVersion,
  creditFacilityId,
  organizationId,
  onUploadStart,
  onUploadEnd,
}: CashBalanceUploadButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Box
      onClick={(e) => {
        setIsOpen(true);
        // stop event propagation
        e.stopPropagation();
      }}
      width="100%"
    >
      {/* button for open form is supplied by caller */}
      {children}

      <Modal isOpen={Boolean(isOpen)} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent padding="0px" pt="8px" width="auto" minW="850px">
          <ModalHeader fontSize="2xl">{modalHeaderText}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <>
              <Text fontWeight="bold" mb="1rem" fontSize="xl">
                {creditFacilityId}
              </Text>
              <UploadCashBalanceForm
                organizationId={organizationId}
                creditFacilityId={creditFacilityId}
                reportingDate={reportingDate}
                fileVersion={fileVersion}
                accept={{
                  'image/png': ['.png'],
                }}
                onClose={onClose}
                onLoading={onUploadStart}
                onSubmit={async () => {}}
                onSuccess={onUploadEnd}
              />
            </>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
